function formatMiles(miles: string) {
  return new Intl.NumberFormat('pt-BR').format(+miles);
}

export { formatMiles };
